$(function() {
  $('#CVbutton').click(function(){
    if ($('#CVForm').css('display') === 'none'){
      $('#CVForm').css('display', 'block');
    } else {
      $('#CVForm').css('display', 'none');
    }
  });
});
